import { utl_renderSingleObject, utl_handleModalClose } from "../base/_utils";
import { staff } from "../data/_staff";
import staffCard from "../components/templates/_staff-card";

// Render objects into matching elements
utl_renderSingleObject(staff, staffCard);
utl_handleModalClose();
